import { FCC } from "@/types/common";
import { TGetCompanyExistsDto, TGetCompanyActiveJobsDto } from "@/api/services/main/company/dtos/get-company.dto";
import { Modal } from "@/components/elements/Modal";
import { Box } from "@mui/system";
import { Stack, Typography, Link } from "@mui/material";
import { secondary, text } from "@/theme/colors";
import { getDynamicRoute } from "@/utils/url";
import { AppRoutes } from "@/routes/config";
import { useParams } from "react-router-dom";

type TCompanyWarningListModalProps = {
  label?: string;
  mode: "duplicate-company" | "active-job";
  open: boolean;
  onClose: () => void;
  onSave?: () => void;
  list: TGetCompanyExistsDto[] | TGetCompanyActiveJobsDto[];
};

export const CompanyWarningListModal: FCC<TCompanyWarningListModalProps> = ({
  label,
  mode,
  open, onClose, onSave, list }) => {
  const handleClick = (mode: string, id: string) => {
    const detailRoute = mode === "duplicate-company" ? getDynamicRoute(AppRoutes.companyDetail, { companyId: id }) : mode === "active-job" ? getDynamicRoute(AppRoutes.jobDetail, { jobId: id }) : undefined;
    if (detailRoute) window.open(detailRoute, "_blank");
  };
  const { companyId } = useParams();
  const labelOk = companyId ? "保存" : "新規で登録する";
  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      onOk={onSave}
      labelClose="キャンセル"
      labelOk={mode === 'duplicate-company' ? labelOk : undefined}
      width={500}
      enableFooter={true}
      hiddenOkBtn={mode === 'active-job'}
    >
      <Box mb={2}>
        <Typography variant="body1" sx={{ mb: 2, mt: 1 }}>
          {label}
        </Typography>
        <Stack
          spacing={1.5}
          sx={{
            maxHeight: "500px",
            overflow: "auto",
          }}
        >
          {list.map((item) => (
            <Box
              key={item.id}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Typography
                component="span"
                sx={{
                  color: text.primary,
                  lineHeight: 1,
                  flexShrink: 0,
                }}
              >
                ・
              </Typography>
              <Link
                component="button"
                variant="body1"
                onClick={() => handleClick(mode, String(item.id))}
                sx={{
                  textDecoration: "none",
                  color: secondary[80],
                  cursor: "pointer",
                  textAlign: "left",
                  "&:hover": {
                    textDecoration: "underline",
                  },
                }}
              >
                {item.name}
              </Link>
            </Box>
          ))}
        </Stack>
      </Box>
    </Modal>
  );
};
